var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedirectArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Go_Arrow",
    "data-name": "Go Arrow",
    transform: "translate(-1314 -662)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_773",
    "data-name": "Rectangle 773",
    width: 18,
    height: 18,
    transform: "translate(1314 662)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M175.306,185.167l4.548-4.583L175.306,176m3.916,4.583H170",
    transform: "translate(1148.073 490.417)",
    fill: "none",
    stroke: "#7f8093",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectArrowIcon);
export default __webpack_public_path__ + "static/media/redirect-arrow-icon.541706dc0eedae3b8aef04ba27f58aa7.svg";
export { ForwardRef as ReactComponent };